import { AppRouter } from './routes/AppRouter';

export function App() {
    return <AppRouter />;
}
